import './FrogLogScreen.scss';
import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Paper } from '@mui/material';
import Grid from '@mui/material/Grid';
import Button from 'src/component/UI/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import SaveAltIcon from '@mui/icons-material/SaveAlt';

import { getLoadingFetchLogs, getLoadingRequestLogs, getLogsByFrogClient } from 'src/module/integration/selector';
import { requestFrogLogs } from 'src/module/integration/action';

export default function FrogLogScreen (props) {
  const dispatch: any = useDispatch();
  const { frogId } = props;
  const requestLogsLoading = useSelector(getLoadingRequestLogs);
  const fetchLogsLoading = useSelector(getLoadingFetchLogs);
  const logs = useSelector(getLogsByFrogClient(frogId));
  const logContainerRef = useRef<HTMLDivElement>(null);


  useEffect(() => {
    if (frogId) {
      dispatch(requestFrogLogs(frogId));
    }
  }, [frogId]);

  useEffect(() => {
    const el = logContainerRef.current;
    if (el) {
      el.scrollTop = el.scrollHeight;
    }
  }, [logs]);

  const handleLogRefreshRequested = () => {
    dispatch(requestFrogLogs(frogId));
  };

  const handleCopyToClipboard = () => {
    const text = logs?.get('logs') ?? '';
    navigator.clipboard.writeText(text);
  };

  const handleSaveToFile = () => {
    const text = logs?.get('logs') ?? '';
    const blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `frog-logs-${frogId ?? 'unknown'}.txt`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div id='frog-logs'>
      <Grid item xs={6} className='frog-logs-screen'>
        <Paper elevation={3} className='log-paper'>
          <div style={{
            marginBottom: '0.75rem',
            display: 'flex',
            justifyContent: 'space-between',
          }}>
            <span>
              {requestLogsLoading
                ? 'Requesting Logs ...'
                : fetchLogsLoading
                  ? 'Fetching Logs ...'
                  : `Last fetched: ${logs?.get('lastFetched') ?? 'N/A'}`}
            </span>
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <Button
                disabled={requestLogsLoading || fetchLogsLoading}
                onClick={handleLogRefreshRequested}
                icon={<RefreshIcon style={{ fontSize: 24 }} />}
              />
              <Button
                className='clipboard'
                disabled={!logs?.get('logs')}
                onClick={handleCopyToClipboard}
                icon={<ContentCopyIcon style={{ fontSize: 14 }} />}
              />
              <Button
                disabled={!logs.get('logs')}
                onClick={handleSaveToFile}
                icon={<SaveAltIcon style={{ fontSize: 24 }} />}
              />
            </div>
          </div>

          {/* Log viewer */}
          <div className='log-container' ref={logContainerRef}>
            {logs?.get('logs')}
          </div>
        </Paper>
      </Grid>

    </div>
  );
}

FrogLogScreen.propTypes = {
  frogId: PropTypes.string,
};

FrogLogScreen.defaultProps = {};
